import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces/interfaces';
import { Dialog } from '../../_config/types'
 
export interface DialogReducer {
    dialog: Dialog
}
 
const initialState: DialogReducer = {
    dialog: null,
}
 
const dialogReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.DIALOG:
            return {
                ...state,
                dialog: action.payload,
            }
        default:
            return state
    }
}
 
export default dialogReducer